define.alias("shared/components/shared/suggestion-text-area", "calendar/components/shared/suggestion-text-area");